<template>
  <div>
    <div class="phonepaymodal" v-if="loading">
      <div>
        <img
          class="logo"
          src="../../assets/images/fonepay_logo.jpg"
          alt="Fonepay"
        />
        <h2 class="normal red">{{ this.loadingmsg }}</h2>
      </div>
    </div>

    <div>
      <head>
        <title>Pay Now</title>
      </head>

      <body>
        <div class="wrapper">
          <BannerOne title="Fonepay" />

          <br />
          <div class="content" v-if="loading">
            <h2 class="normal red">{{ this.loadingmsg }}</h2>
          </div>

          <div class="content" v-if="!loading && !value">
            <h2 class="normal">Make Payment For</h2>
            <h2 class="trans-id">#{{ this.orderID }}</h2>

            <!-- <div class="custom-button green" @click="handlePayment">Proceed</div> -->
          </div>

          <br />

          <div v-if="value && !loading">
            <span>
              <h2 class="normal">Please Scan to Pay</h2>

              <img
                class="logo"
                src="../../assets/images/fonepay_logo.jpg"
                alt="Fonepay"
              />
            </span>

            <qrcode-vue :value="value" :size="size" level="H" />
          </div>

          <!-- eo content -->
        </div>
        <!-- eo wrapper -->
      </body>
    </div>
  </div>
</template>

<script>
import BannerOne from "../../components/BannerOne.vue";
import axios from "axios";
import { CartData, FonePayInfo } from "../../services/storage.service";
import router from "../../router";
import { mapActions } from "vuex";
import QrcodeVue from "qrcode.vue";

export default {
  name: "FonepayPaymentExt",
  components: {
    BannerOne,
    QrcodeVue,
  },
  data() {
    return {
      amount: JSON.stringify(CartData.getExtCartAmount()),
      orderID: JSON.stringify(CartData.getExtCartId()),
      loading: false,
      loadingmsg: "",
      value: "",
      size: 250,
      paymentProgress: false,
      paymentSuccess: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.paymentSuccess === false) {
      console.log("Payment Not Success Or In Progress", this.paymentSuccess);
      this.$confirm({
        title:
          "Your Transaction is processing, Please don't close this window.",
        okText: "Close Window",
        okType: "primary",
        cancelText: "Cancel",
        onOk() {
          next();
        },
        onCancel() {
          next(false);
        },
      });
    }
  },
  created: function () {
    // add event listener to handle tab/browser closing
    if (this.paymentSuccess === false) {
      window.addEventListener("beforeunload", this.onUserTabClose);
    }
    // window.addEventListener("onbeforeunload", this.onUserTabClose);
  },
  mounted() {
    this.handlePayment();
  },
  methods: {
    ...mapActions(["clearCart"]),

    onUserTabClose(e) {
      this.$notification.error({
        message: "Payment in Progress!",
        description:
          "Your Transaction is processing, Please don't close this window.",
      });
      e.preventDefault();
      e.returnValue = "";

      return "Your Transaction is processing, Please don't close this window.";
    },

    connectWebSocket(url) {
      let connection = new WebSocket(url);

      connection.onopen = (event) => {
        // console.log("ON OPEN", event);
      };

      connection.onmessage = (event) => {
        // console.log("On Message", event);
        let data = JSON.parse(event.data);
        let innerdata = JSON.parse(data.transactionStatus);
        // console.log("innerdata.success", innerdata.success);
        // console.log("innerdata.paymentSuccess", innerdata.paymentSuccess);

        if (innerdata.paymentSuccess) {
          this.paymentSuccess = true;
          this.checkPaymentStatus();
        }

        if (innerdata.success) {
          this.loading = true;
          this.loadingmsg =
            "Your Transaction is Processing, Please Don't Close This Window.";
        }
      };

      connection.onclose = (event) => {
        // console.log("ON CLOSE", event);
        this.value = "";
        this.loading = false;
        this.$notification.error({
          message: "Payment Failed!",
          description: "Fonepay payment failed. Please try again.",
        });
        router.replace("/p/fonepay/failure");
      };

      connection.onerror = (event) => {
        // console.log("ON ERROR", event);
        this.loading = false;
        this.value = "";
        this.$notification.error({
          message: "Payment Failed!",
          description: "Fonepay payment failed. Please try again.",
        });
        router.replace("/p/fonepay/failure");
      };
    },

    generateNewOrderID() {
      const randomNo = Math.floor(Math.random() * 9000) + 1000;
      const newOrderID = this.orderID + "-" + randomNo;
      return newOrderID;
    },

    checkPaymentStatus() {
      let prn = FonePayInfo.getExtPRN();

      axios
        .post(`https://deus.khaanpin.com/appapi/checkfonepayqr/`, {
          prn: prn,
        })
        .then((response) => {
          if (response.data.error == false) {
            FonePayInfo.clearExtPRN();
            this.loading = false;
            this.value = "";
            FonePayInfo.setTransactionId(response.data.data.trans_id);
            FonePayInfo.setOrderId(response.data.data.order_id);
            this.$notification.success({
              message: "Payment Success!",
              description: "Payment completed successfully.",
            });
            router.replace("/p/fonepay/success");
          } else {
            this.value = "";
            this.loading = false;
            this.$notification.error({
              message: "Payment Failed!",
              description: "Fonepay payment failed. Please try again.",
            });
            router.replace("/p/fonepay/failure");
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },

    async handlePayment() {
      this.loading = true;
      this.loadingmsg = "Please Wait ...";

      let prn = this.generateNewOrderID();

      FonePayInfo.setExtPRN(prn);

      let qrRequestData = {
        amount: this.amount,
        remarks1: this.orderID,
        remarks2: "khaanpin",
        prn: prn,
      };

      axios
        .post(`https://deus.khaanpin.com/appapi/getfonepayqr/`, qrRequestData)
        .then((response) => {
          if (response.data.error == false) {
            let data = response.data.data;

            this.loading = false;
            this.value = data.qrMessage;
            this.connectWebSocket(data.thirdpartyQrWebSocketUrl);
          } else {
            this.loading = false;
            // console.log("RESPONSE DATA", response.data);
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

body {
  background: #fefefe;
}
.wrapper {
  text-align: center;
  font-family: sans-serif;
  margin-top: 20px;
}
h2 {
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 20px;
  color: #333;
}
.logo {
  width: 150px;
  margin-top: 40px;
}
.content {
  margin-top: 20px;
  align-items: center;
}

.type {
  font-size: 34px;
  letter-spacing: 14px;
  background: $brand-color;
  padding: 20px 60px;
  color: #fff;
  display: inline-block;
}
.trans-id {
  color: $brand-color;
  font-family: $main-font;
  font-size: 20px;
}
a {
  display: inline-block;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 5px;
  margin-top: 40px;
  color: #333;
}

.custom-button {
  height: 40px;
  width: 160px;
  margin: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.green {
    background: #60b246;
    border-color: #60b246;
    &:hover {
      color: white;
    }
  }
  &.hide {
    display: none;
  }
}

.red {
  color: red;
  font-size: 15px;
}

.logo {
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.phonepaymodal {
  background: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
